const QueryKeys = {
  currentUser: () => ['currentUser'],
  tableauToken: (type: string, workbookUrl: string, id?: string) => [
    type,
    workbookUrl,
    id,
  ],
}

export default QueryKeys
